import { Link } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import PermissionErrorPage from "../../pages/shared/permissionError";
import Badge from 'react-bootstrap/Badge';
import { questionService } from '../../services/api';
import { storageService } from '../../services/storage';
import { USER_ROLES, DIFFICULTY_BADGES } from '../../utils/constants';
import LoadingSpinner from '../ui/LoadingSpinner';
import '../../styles/components/features/question-table.css';

function QuestionTable() {
    
    const [questions, setQuestions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    
    const fetchQuestions = async () => {
        setIsLoading(true);
        try {
            const questionsData = await questionService.getQuestions();
            setQuestions(questionsData);
        } catch (error) {
            console.error('Error fetching questions:', error);
            alert('Failed to load questions');
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        fetchQuestions();
    }, []);
    return(
        <div>
            {(storageService.getRole() === USER_ROLES.INSTRUCTOR) ? (
        <>
        <h1>All Questions in the Question Box</h1>
        <div>
            <Table striped bordered hover>
                <tr>
                    <thead>
                        <th>ID</th>
                        <th>Topic</th>
                        <th>Question</th>
                        <th>Answer</th>
                        <th>Test Cases</th>
                        <th>Function Name</th>
                        <th>Difficulty</th>
                        <th>Next ID</th>
                        <th>Edit</th>
                        <th>Delete</th>
                        <th>See Question Efficiency</th>
                        
                    
                    </thead>
                    <tbody>
                        
                        {isLoading ? (
                            <tr><td colSpan="10"><LoadingSpinner /></td></tr>
                        ) : (
                            questions.map((question) => (
                            <tr>
                                <td>{question.q_id}</td>
                                <td>{question.topic}</td>
                                <td><div dangerouslySetInnerHTML={{__html: question.question}} /></td>
                                <td>{question.answer}</td>
                                <td>{question.test_cases}</td>
                                <td>{question.function_name}</td>
                                <td>
                                    {DIFFICULTY_BADGES[question.difficulty] && (
                                        <Badge pill bg={DIFFICULTY_BADGES[question.difficulty].bg}>
                                            {DIFFICULTY_BADGES[question.difficulty].text}
                                        </Badge>
                                    )}
                                </td>
                                <td>{question.next_id}</td>
                                <td>
                                    {" "}
                                    <Link to={`/editquestion/${question.q_id}`}>
                                        <Button variant="primary" size="sm">Edit</Button>
                                    </Link>
                                    </td>
                                    <td>
                                    {" "}

                                    {" "}
                                    <Button 
                                        variant="danger" 
                                        size="sm"
                                        onClick={async () => {
                                            if (window.confirm('Are you sure you would like to delete this question?')) {
                                                try {
                                                    await questionService.deleteQuestion(question.q_id);
                                                    alert('Question successfully deleted.');
                                                    fetchQuestions();
                                                } catch (error) {
                                                    console.error('Delete error:', error);
                                                    alert('Failed to delete question.');
                                                }
                                            }
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </td>
                                <td>
                                    <Link to={`/qEfficiency/${question.q_id}`}>
                                        <Button variant="secondary" size="sm">Efficiency</Button>
                                    </Link>
                                </td>
                            </tr>
                            ))
                        )}
                        
                    </tbody>
                </tr>
            </Table>
        </div>

        <Link to="/instructorAddQs"><Button className="action-button">Add Questions</Button></Link>
        </>
        ): (
            <PermissionErrorPage/>
        )}
        </div>
    );
}
export default QuestionTable;